module.exports = __webpack_public_path__ + "static/media/atacado_fundo_branco.2dd44f79.png";